<nb-card [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-card-header [formGroup]="diaForm">
    <div *ngIf="mode === 'products'" class="form-inline">
      <nb-form-field fullWidth>
        <button
          *ngIf="groupSelected"
          nbPrefix
          nbButton
          ghost
          size="small"
          status="danger"
          (click)="removeCatalog('groups')"
        >
          <nb-icon icon="close-outline"></nb-icon>
        </button>
        <nb-select
          class="type-select"
          size="small"
          [placeholder]="groupSelected ? '' : 'Chọn ngành hàng'"
          [(ngModel)]="groupSelected"
          formControlName="groupSelected"
          (selectedChange)="onSearch()"
        >
          <nb-option *ngFor="let opt of groups" [value]="opt.id">{{
            opt.title
          }}</nb-option>
        </nb-select>
      </nb-form-field>

      <nb-form-field fullWidth>
        <button
          *ngIf="categorySelected"
          nbPrefix
          nbButton
          ghost
          size="small"
          status="danger"
          (click)="removeCatalog('categories')"
        >
          <nb-icon icon="close-outline"></nb-icon>
        </button>
        <nb-select
          class="type-select"
          size="small"
          [placeholder]="categorySelected ? '' : 'Chọn loại hàng'"
          [(ngModel)]="categorySelected"
          formControlName="categorySelected"
          (selectedChange)="onSearch()"
        >
          <nb-option *ngFor="let opt of categories" [value]="opt.id">{{
            opt.title
          }}</nb-option>
        </nb-select>
      </nb-form-field>
    </div>
    <div class="form-inline">
      <nb-form-field fullWidth>
        <!-- <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon> -->
        <button
          nbPrefix
          nbButton
          ghost
          shape="round"
          status="info"
          size="small"
          (click)="addProduct()"
        >
          <nb-icon
            [icon]="isCreate ? 'chevron-up-outline' : 'chevron-down-outline'"
          ></nb-icon>
        </button>
        <input
          type="text"
          nbInput
          fullWidth
          shape="semi-round"
          class="form-control"
          placeholder="Nhập để tìm kiếm"
          formControlName="title"
          [(ngModel)]="strSearch"
          (ngModelChange)="onSearch()"
          #title
        />
        <!-- <button
          *ngIf="strSearch !== ''"
          nbSuffix
          nbButton
          ghost
          size="small"
          status="danger"
          (click)="removeSearch()"
        >
          <nb-icon icon="close-outline"></nb-icon>
        </button> -->
      </nb-form-field>
      <button
        *ngIf="mode === 'products'"
        nbButton
        outline
        shape="semi-round"
        status="primary"
        size="small"
        (click)="onNew()"
      >
        <span>{{ "buttons.create" | translate }}</span>
      </button>

      <nb-form-field *ngIf="mode === 'receipt' || mode === 'purchase'">
        <nb-icon nbPrefix icon="cube-outline" pack="eva"></nb-icon>
        <input
          type="text"
          nbInput
          shape="semi-round"
          class="form-control"
          style="width: 100px"
          placeholder="Nhập số lượng"
          formControlName="quantity"
          [(ngModel)]="quantity"
          #strQuantity
          [ngxNumberFormat]="formatCurrency"
        />
      </nb-form-field>
    </div>
    <div class="form-inline" *ngIf="isCreate">
      <nb-form-field>
        <input
          #createUnit
          type="text"
          nbInput
          shape="semi-round"
          class="form-control"
          style="width: 80px"
          placeholder="ĐVT"
          formControlName="unit"
          (keydown.enter)="elemFocus('createPrice')"
        />
      </nb-form-field>

      <nb-form-field>
        <input
          #createPrice
          type="text"
          nbInput
          shape="semi-round"
          class="form-control"
          style="width: 120px"
          placeholder="Giá bán"
          formControlName="price"
          (keydown.enter)="create()"
          [ngxNumberFormat]="formatCurrency"
        />
      </nb-form-field>

      <button
        type="submit"
        nbButton
        hero
        shape="semi-round"
        status="info"
        size="small"
        (click)="create()"
        [disabled]="submitted || !diaForm.valid"
        [class.btn-pulse]="submitted"
      >
        <nb-icon nbPrefix icon="save-outline"></nb-icon>
        Lưu
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="table-responsive">
      <table class="table align-items-center table-striped">
        <thead class="thead-light">
          <tr>
            <th scope="col">Mã hàng</th>
            <th scope="col">Tên hàng</th>
            <th *ngIf="mode !== 'loan'" scope="col">ĐVT</th>
            <th *ngIf="mode === 'receipt' || mode === 'products'" scope="col">
              Giá bán
            </th>
            <th *ngIf="mode === 'purchase'" scope="col">Giá mua</th>
            <th *ngIf="mode === 'receipt' || mode === 'purchase'" scope="col">
              SL tồn
            </th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let item of display
                | paginate : { itemsPerPage: itemsPerPage, currentPage: page };
              let i = index
            "
            [ngClass]="indexSelected === i ? 'bg-select' : ''"
          >
            <td>
              <button
                *ngIf="mode !== 'products'"
                nbButton
                ghost
                status="info"
                size="small"
                [disabled]="submitted"
                [class.btn-pulse]="submitted"
                (click)="edit(item)"
              >
                <nb-icon icon="edit-2-outline"></nb-icon>
              </button>
              {{ item.barcode }}
            </td>
            <td>
              {{ item.title }}
            </td>
            <td *ngIf="mode !== 'loan'">
              {{ item.unitName }}
            </td>
            <td *ngIf="mode === 'receipt' || mode === 'products'">
              <b class="text-primary">
                {{ (item.price ? item.price : 0) | number }}</b
              >
            </td>
            <td *ngIf="mode === 'purchase'">
              <b class="text-primary">
                {{ (item.costPrice ? item.costPrice : 0) | number }}</b
              >
            </td>
            <td *ngIf="mode === 'receipt' || mode === 'purchase'">
              <b
                [ngClass]="
                  item.balanceQuantity < 0 ? 'text-danger' : 'text-primary'
                "
              >
                {{
                  (item.balanceQuantity ? item.balanceQuantity : 0) | number
                }}</b
              >
            </td>
            <td>
              <button
                *ngIf="mode === 'products'"
                nbButton
                ghost
                status="info"
                size="small"
                [disabled]="submitted"
                [class.btn-pulse]="submitted"
                (click)="edit(item)"
              >
                <nb-icon icon="edit-2-outline"></nb-icon>
              </button>

              <button
                *ngIf="mode !== 'products'"
                nbButton
                shape="round"
                outline
                status="success"
                size="small"
                [disabled]="submitted"
                [class.btn-pulse]="submitted"
                (click)="selected(item)"
              >
                <nb-icon icon="checkmark-outline"></nb-icon>
              </button>

              <button
                *ngIf="mode !== 'products'"
                nbButton
                shape="round"
                outline
                status="warning"
                size="small"
                [disabled]="submitted"
                [class.btn-pulse]="submitted"
                (click)="viewStock(item)"
              >
                <nb-icon icon="layers-outline"></nb-icon>
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="6">
              <strong class="text-hint"
                >Tổng số: {{ display.length | number }}</strong
              >
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <pagination-controls
      (pageChange)="pageChange($event)"
    ></pagination-controls>

    <button
      *ngIf="mode !== 'products'"
      nbButton
      outline
      shape="semi-round"
      status="primary"
      size="tiny"
      (click)="onNew()"
    >
      <span>{{ "buttons.create" | translate }}</span>
    </button>
  </nb-card-footer>
</nb-card>
